import {
  USER_ID,
  ACCESS_TOKEN,
  ACCESS_TOKEN_EXPIRE_TIME,
} from '../constants/localStorageKeys';

export default function getUserAuthDataFromLocalStorage() {
  return {
    accessToken: localStorage.getItem(ACCESS_TOKEN),
    accessTokenExpireTime: localStorage.getItem(ACCESS_TOKEN_EXPIRE_TIME),
    userId: localStorage.getItem(USER_ID),
  };
}



// WEBPACK FOOTER //
// ./src/utils/getUserAuthDataFromLocalStorage.js